import { useMemo } from "react";

import { useUser } from "@components/user-context";
import { Currencies } from "@north-beam/nb-common";

import {
  FormattedNumberInput,
  type FormattedNumberInputProps,
} from "./formatted-number-input";

export const CurrencyInput = (props: FormattedNumberInputProps) => {
  const { user } = useUser();

  const currencySymbol = useMemo(() => {
    const code = user.currencies.currentCurrency;
    return Currencies.getAttribute(code, "symbol") ?? code;
  }, [user.currencies.currentCurrency]);

  return <FormattedNumberInput leftIcon={currencySymbol} {...props} />;
};
